<ng-container *ngIf="awardsKeyData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="awardsKeyData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div  *ngIf="awardsKeyData.award as award">
    <div class="TableTitle TableTitle--withBackButton">
      <h2 class="Award">Award</h2>
      <h1><a (click)="analyticsService.pushTitleClickEvent()" [routerLink]="'/awards/country/'+awardsKeyData.countryCode">{{ awardsKeyData.award.countryName }}</a> {{ awardsKeyData.award.awardKey | delete2FirstChar }}<span *ngIf="award.countryName || award.awardKey">&nbsp;&ndash;</span>&nbsp;{{ award.shortTitle }}</h1>
      <a href="javascript:void(0)" class="Button Button--blue" (click)="goBack()">Back</a>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table ResponsiveTable">
          <thead>
            <tr>
              <th scope="col" [class.DisplayNone]="!awardsKeyData.awardDate && !award.awardDateComment">Date</th>
              <th scope="col">Award type</th>
              <th scope="col">Status</th>
              <th scope="col" [class.DisplayNone]="!award.population">Population (at time of award)</th>
              <th scope="col" [class.DisplayNone]="!award.source">Source</th>
              <th scope="col" [class.DisplayNone]="award.reports.length===0">Cullen report</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-th="Date" [class.DisplayNone]="!awardsKeyData.awardDate && !award.awardDateComment">
                <!-- LIGHT CONTENT -->
                <div *ngIf="awardsKeyData.awardDate" [innerHtml]="isSpectrumLightContent(awardsKeyData.awardDate)"></div>
                <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
                <div *ngIf="award.awardDateComment" class="RichText" [innerHtml]="isSpectrumLightContent(award.awardDateComment) | forceTarget" [class.DisplayNone]="award.awardDateComment.length===1"></div>
              </td>
              <td data-th="Award type">
                <!-- <div *ngIf="award.awardType">{{ ('AwardType.' + award.awardType) | translate }}</div> -->
                <!-- LIGHT CONTENT -->
                <div *ngIf="awardsKeyData.awardTypeAsString" [innerHtml]="isSpectrumLightContent(awardsKeyData.awardTypeAsString)"></div>
                <!-- LIGHT COMMENT -->
                <div *ngIf="award.typeComment && award.typeComment != 'BLUR_COMMENT'" class="RichText" [innerHtml]="award.typeComment | forceTarget" [class.DisplayNone]="award.typeComment.length===1"></div>
              </td>
              <td data-th="Status">
                <div *ngIf="award.status">{{ award.status }}</div>
                <!-- LIGHT COMMENT -->
                <div *ngIf="award.statusComment && award.statusComment != 'BLUR_COMMENT'" class="RichText" [innerHtml]="award.statusComment | forceTarget" [class.DisplayNone]="award.statusComment.length===1"></div>
              </td>
              <td data-th="Population (at time of award)" [class.DisplayNone]="!award.population">
                <!-- LIGHT CONTENT -->
                <div [innerHtml]="isSpectrumLightContent(awardsKeyData.populationAsString)"></div>
              </td>
              <td data-th="Source" [class.DisplayNone]="!award.source">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.source" class="RichText" [innerHtml]="isSpectrumLightContent(award.source) | forceTarget"></div>
              </td>
              <td data-th="Cullen report" [class.DisplayNone]="award.reports.length===0">
                <div *ngFor="let report of award.reports" class="Loop">
                  <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="report.displayName">
                    {{ report.displayName | capitalize }}
                  </a>
                  <a [href]="getDocumentUrl(report.uniqueNumber)" target="fromSpectrum" *ngIf="!report.displayName">
                    {{ displayService.displayReportNames(report.uniqueNumber) }}
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile ResponsiveTable--withMargin" [class.DisplayNone]="hidePriceTable(award)">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col" *ngFor="let awardband of awardsKeyData.awardbands">{{ awardband.bandName }}</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr [class.DisplayNone]="awardsKeyData.awardbands.length===0 && !awardsKeyData.mhzOffered">
              <td data-th="">
                <b>Spectrum offered (MHz)</b>
              </td>
              <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands">
                <!-- LIGHT CONTENT -->
                <span [innerHtml]="isSpectrumLightContent(awardband.mhzOffered)"></span>
              </td>
              <td data-th="Total">
                <!-- LIGHT CONTENT -->
                <span [innerHtml]="isSpectrumLightContent(awardsKeyData.mhzOffered)"></span>
              </td>
              <td data-th="Comment" class="Comment Comment--cell" *ngIf="award.mhzOfferedComment" [class.DisplayNone]="award.mhzOfferedComment.length===1">
                <div *ngIf="award.mhzOfferedComment" class="RichText" [innerHtml]="award.mhzOfferedComment | forceTarget"></div>
              </td>
            </tr>
            <!-- LIGHT COMMENT WITH CONTENT LOOK -->
            <tr class="Comment Comment--row" *ngIf="award.mhzOfferedComment" [class.DisplayNone]="award.mhzOfferedComment.length===1">
              <td colspan="20">
                <table class="BasicResponsiveTable">
                  <tbody>
                    <tr>
                      <td>
                        <span *ngIf="award.mhzOfferedComment" class="RichText ForcedColor" [innerHtml]="isSpectrumLightContent(award.mhzOfferedComment | forceTarget)"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr [class.DisplayNone]="awardsKeyData.awardbands.length===0 && !awardsKeyData.mhzAwarded">
              <td data-th="">
                <b>Spectrum awarded (MHz)</b>
              </td>
              <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands">
                <!-- LIGHT CONTENT -->
                <span *ngIf="awardband.mhzAwarded === '/'" [innerHtml]="isSpectrumLightContent(awardband.mhzAwarded)"></span>
                <a [routerLink]="getLicenceLink(awardsKeyData.countryCode, awardband.bandName)" *ngIf="awardband.mhzAwarded != '/'" [innerHtml]="isSpectrumLightContent(awardband.mhzAwarded)"></a>                
              </td>
              <td data-th="Total">
                <!-- LIGHT CONTENT -->
                <span [innerHtml]="isSpectrumLightContent(awardsKeyData.mhzAwarded)"></span>
              </td>
              <td data-th="Comment" class="Comment Comment--cell" *ngIf="award.mhzAwardedComment" [class.DisplayNone]="award.mhzAwardedComment.length===1">
                <div *ngIf="award.mhzAwardedComment" class="RichText" [innerHtml]="award.mhzAwardedComment | forceTarget"></div>
              </td>
            </tr>
            <!-- LIGHT COMMENT WITH CONTENT LOOK -->
            <tr class="Comment Comment--row" *ngIf="award.mhzAwardedComment" [class.DisplayNone]="award.mhzAwardedComment.length===1">
              <td colspan="20">
                <table class="BasicResponsiveTable">
                  <tbody>
                    <tr>
                      <td>
                        <span *ngIf="award.mhzAwardedComment" class="RichText  ForcedColor" [innerHtml]="isSpectrumLightContent(award.mhzAwardedComment | forceTarget)"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr [class.DisplayNone]="awardsKeyData.awardbands.length===0 && !awardsKeyData.pricePaid">
              <td data-th="">
                <b>Price paid</b>
              </td>
              <ng-container *ngIf="currencyService.isEuro()">
                <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands, let i = index">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardband.pricePaid.priceEUR)"></span>
                </td>
                <td data-th="Total">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardsKeyData.pricePaid.priceEUR)"></span>
                </td>
              </ng-container>
              <ng-container *ngIf="!currencyService.isEuro()">
                <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands, let i = index">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardband.pricePaid.priceUSD)"></span>
                </td>
                <td data-th="Total">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardsKeyData.pricePaid.priceUSD)"></span>
                </td>
              </ng-container>
              <td data-th="Comment" class="Comment Comment--cell" *ngIf="award.pricePaidComment" [class.DisplayNone]="award.pricePaidComment.length===1">
                <div *ngIf="award.pricePaidComment" class="RichText" [innerHtml]="isSpectrumLightContent(award.pricePaidComment | forceTarget)"></div>
              </td>
            </tr>
            <!-- LIGHT COMMENT WITH CONTENT LOOK -->
            <tr class="Comment Comment--row" *ngIf="award.pricePaidComment" [class.DisplayNone]="award.pricePaidComment.length===1">
              <td colspan="20">
                <table class="BasicResponsiveTable">
                  <tbody>
                    <tr>
                      <td>
                        <span *ngIf="award.pricePaidComment" class="RichText ForcedColor" [innerHtml]="isSpectrumLightContent(award.pricePaidComment | forceTarget)"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr [class.DisplayNone]="awardsKeyData.awardbands.length===0 && !awardsKeyData.pricePerMhz">
              <td data-th="">
                <b>Price/MHz</b>
              </td>
              <ng-container *ngIf="currencyService.isEuro()">
                <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardband.pricePerMhz.priceEUR)"></span>
                </td>
                <td data-th="Total">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardsKeyData.pricePerMhz.priceEUR)"></span>
                </td>
              </ng-container>
              <ng-container *ngIf="!currencyService.isEuro()">
                <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardband.pricePerMhz.priceUSD)"></span>
                </td>
                <td data-th="Total">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardsKeyData.pricePerMhz.priceUSD)"></span>
                </td>
              </ng-container>
            </tr>
            <tr [class.DisplayNone]="awardsKeyData.awardbands.length===0 && !awardsKeyData.pricePerMhzPerPerson">
              <td data-th="">
                <b>Price/MHz/pop.</b>
              </td>
              <ng-container *ngIf="currencyService.isEuro()">
                <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardband.pricePerMhzPerPerson.priceEUR)"></span>
                </td>
                <td data-th="Total">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardsKeyData.pricePerMhzPerPerson.priceEUR)"></span>
                </td>
              </ng-container>
              <ng-container *ngIf="!currencyService.isEuro()">
                <td [attr.data-th]="awardband.bandName" *ngFor="let awardband of awardsKeyData.awardbands">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardband.pricePerMhzPerPerson.priceUSD)"></span>
                </td>
                <td data-th="Total">
                  <!-- LIGHT CONTENT -->
                  <span [innerHtml]="isSpectrumLightContent(awardsKeyData.pricePerMhzPerPerson.priceUSD)"></span>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <table class="table ResponsiveTable" [class.DisplayNone]="hideReservePriceTable(award)">
          <thead>
            <tr>
              <th scope="col" [class.DisplayNone]="!award.reservePrice">Reserve price</th>
              <th scope="col" [class.DisplayNone]="!award.restrictionsBidders">Restrictions for bidders</th>
              <th scope="col" [class.DisplayNone]="!award.spectrumCapRules">Spectrum cap rules</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-th="Reserve price" [class.DisplayNone]="!award.reservePrice">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.reservePrice" class="RichText" [innerHtml]="isSpectrumLightContent(award.reservePrice) | forceTarget"></div>
              </td>
              <td data-th="Restrictions for bidders" [class.DisplayNone]="!award.restrictionsBidders">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.restrictionsBidders" class="RichText" [innerHtml]="isSpectrumLightContent(award.restrictionsBidders) | forceTarget"></div>
              </td>
              <td data-th="Spectrum cap rules" [class.DisplayNone]="!award.spectrumCapRules">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.spectrumCapRules" class="RichText" [innerHtml]="isSpectrumLightContent(award.spectrumCapRules) | forceTarget"></div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table ResponsiveTable" [class.DisplayNone]="hideAccessTable(award)">
          <thead>
            <tr>
              <th scope="col" [class.DisplayNone]="!award.accessMVNOs">Access for MVNOs</th>
              <th scope="col" [class.DisplayNone]="!award.accessServiceProviders">Access for service providers</th>
              <th scope="col" [class.DisplayNone]="!award.accessNationalRoaming">Access for national roaming</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-th="Access for MVNOs" [class.DisplayNone]="!award.accessMVNOs">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.accessMVNOs" class="RichText" [innerHtml]="isSpectrumLightContent(award.accessMVNOs) | forceTarget"></div>
              </td>
              <td data-th="Access for service providers" [class.DisplayNone]="!award.accessServiceProviders">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.accessServiceProviders" class="RichText" [innerHtml]="isSpectrumLightContent(award.accessServiceProviders) | forceTarget"></div>
              </td>
              <td data-th="Access for national roaming" [class.DisplayNone]="!award.accessNationalRoaming">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.accessNationalRoaming" class="RichText" [innerHtml]="isSpectrumLightContent(award.accessNationalRoaming) | forceTarget"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xl-6">
        <table class="table ResponsiveTable" [class.DisplayNone]="hideObligationsTable(award)">
          <thead>
            <tr>
              <th scope="col" [class.DisplayNone]="!award.coverageObligations">Coverage obligations</th>
              <th scope="col" [class.DisplayNone]="!award.otherObligations">Other obligations</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-th="Coverage obligations" [class.DisplayNone]="!award.coverageObligations">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.coverageObligations" class="RichText" [innerHtml]="isSpectrumLightContent(award.coverageObligations) | forceTarget"></div>
              </td>
              <td data-th="Other obligations" [class.DisplayNone]="!award.otherObligations">
                <!-- LIGHT CONTENT -->
                <div *ngIf="award.otherObligations" class="RichText" [innerHtml]="isSpectrumLightContent(award.otherObligations) | forceTarget"></div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- LIGHT COMMENT -->
        <table class="table ResponsiveTable" *ngIf="award.awardComment != 'BLUR_COMMENT'" [class.DisplayNone]="!award.awardComment">
          <thead>
            <tr>
              <th scope="col">Comment</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-th="Comment">
                <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
                <div *ngIf="award.awardComment" class="RichText" [innerHtml]="isSpectrumLightContent(award.awardComment)"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>